import Cookies from 'js-cookie'
import jwt from 'jsonwebtoken'
import { dateTimeFormat } from '../constant'
import CookiesManager from '../core/business/CookiesManager'
import moment from 'moment'

const BSRS_ACCESS_TOKEN = 'bsrs_access_token'
const ACCESS_TOKEN = 'access_token'
const EXPIRES_ON = 'expires_on'
const REFRESH_TOKEN = 'refresh_token'
const REFRESH_TOKEN_EXPIRES_DATE = "REFRESH_TOKEN_EXPIRES_DATE"
const SERVICE_TOKEN = 'service_token'
const ROOM = 'room'
const API_URL = 'api_server_url'
const CLIENT_ID = 'client_id'
const SERVICE_TOKEN_EXPIRES = 'service_token_expires_on'
const IS_INTEGRATION = 'isIntegration'
const USER_ID = 'id'
const LIMIT_USERS = 'limitUser'
const FIRST_NAME = 'firstName'
const EMAIL = 'email'
const IS_USER_AD = 'isUserActiveDirectory'
const SYSTEM = 'system'
const COMPANY_CODE = 'companyCode'
const IS_REMEMBER = 'isRemember'

const IS_IMPORTUSERFROMO365 = 'isImportUserFromO365'
const IS_IMPORTUSERFROMEXCEL = 'isImportUserFromExcel'
const IS_IMPORTUSERFROMAD = 'isImportUserFromAD'

const IS_SYNCROLEANDPOLICY = 'isSyncRoleAndPolicy'

const expiresDay = 7

export function getCookie(key) {
    const bCookies = new CookiesManager()
    return bCookies.getData(key)
}

export function setCookie(key, value, expires) {
    const bCookies = new CookiesManager()
    let data = {}
    data[key] = value

    if (expires) {
        bCookies.expires = expires
        data[IS_REMEMBER] = true
    }

    bCookies.setDatas(data)
}

export function removeCookie(key) {
    const bCookies = new CookiesManager()
    bCookies.removeData(key)
}

export function getAccessToken() {
    return getCookie(ACCESS_TOKEN)
}

export function getRoom() {
    return getCookie(ROOM)
}

export function getService() {
    return getCookie({ CLIENT_ID, API_URL })
}

export function getAllToken() {
    // if (!getCookie(BSRS_ACCESS_TOKEN)) return {}
    return {
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN),
        userId: getCookie(USER_ID),
        refreshTokenExpireDate: getCookie(REFRESH_TOKEN_EXPIRES_DATE)
    }
}

export function getExpiresToken() {
    return getCookie(EXPIRES_ON)

}

export function setToken({
    access_token,
    expires_on,
    refresh_token
}) {
    setCookie(ACCESS_TOKEN, access_token)
    setCookie(EXPIRES_ON, expires_on)
    setCookie(REFRESH_TOKEN, refresh_token)
}

export function clearToken() {
    removeCookie(ACCESS_TOKEN)
    removeCookie(EXPIRES_ON)
    removeCookie(REFRESH_TOKEN)
    removeCookie(REFRESH_TOKEN_EXPIRES_DATE)
    removeCookie(SERVICE_TOKEN)
    removeCookie(SERVICE_TOKEN_EXPIRES)
    removeCookie(ROOM)
    removeCookie(USER_ID)
    removeCookie(IS_INTEGRATION)

    removeCookie(IS_IMPORTUSERFROMO365)
    removeCookie(IS_IMPORTUSERFROMEXCEL)
    removeCookie(IS_IMPORTUSERFROMAD)
}

export function getServiceToken() {
    if (!getCookie(BSRS_ACCESS_TOKEN)) return {}
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
        user_id: getCookie(USER_ID),
        bsrsToken: getCookie(BSRS_ACCESS_TOKEN),
        isIntegration: getCookie(IS_INTEGRATION)
    }
}

export function getIsUserActiveDirectory() {
    return getCookie(IS_USER_AD)
}

export function setServiceToken({
    token,
    expires_on
}) {
    if (typeof (token) !== undefined)
        setCookie(SERVICE_TOKEN, token)
    if (typeof (expires_on) !== undefined)
        setCookie(SERVICE_TOKEN_EXPIRES, expires_on)
}

export function getIsRemember() {
    const isRemember = getCookie(IS_REMEMBER) === 'true' || getCookie(IS_REMEMBER) === true ? true : false
    return isRemember
}

export function resetExpire() {
    const isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false
    if (isRemember === true) {
        const keys = Object.keys(Cookies.get())
        keys.forEach(key => setCookie(key, getCookie(key), expiresDay))
    }
}

export async function setRefreshToken(res) {
    if (res.value) {
        const { token, expires_on, refreshToken, refreshTokenExpiresDate } = res.value
        const isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false
        let expires = null
        if (isRemember === true) {
            expires = expiresDay
        }
        if (token) {
            setCookie(BSRS_ACCESS_TOKEN, token, expires)
        }
        if (expires_on) {
            setCookie(EXPIRES_ON, expires_on, expires)
        }
        if (refreshToken) {
            setCookie(REFRESH_TOKEN, refreshToken, expires)
            if (!!refreshTokenExpiresDate) {
                setCookie(REFRESH_TOKEN_EXPIRES_DATE, refreshTokenExpiresDate, expires)
            } else {
                let decode = await jwt.decode(refreshToken)
                if (!!decode) {
                    let exp = moment.unix(decode.exp)
                    setCookie(REFRESH_TOKEN_EXPIRES_DATE, exp.format(dateTimeFormat.apiFullDateTime), expires)
                }
            }
        }
    }
}

export function getUserInfo(access_token) {
    if (!access_token) return {}

    const {
        iat,
        exp,
        appid,
        name,
        unique_name: email
    } = jwt.decode(access_token)

    return {
        iat,
        exp,
        appid,
        name,
        email
    }
}

export function getUserId() {
    return getCookie(USER_ID)
}

export function getUserEmail() {
    return getCookie(EMAIL)
}

export function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN)
}

export async function setBSRSToken(bsrsToken) {
    const { isRemember, isIntegration, expires_on, token, refreshToken, refreshTokenExpiresDate, id, company, firstName, email, isUserActiveDirectory, system_key, companyCode,
        isImportUserFromO365, isImportUserFromExcel, isImportUserFromAD, isSyncRoleAndPolicy } = bsrsToken //isUseActiveDirectory,
    let limitUser = 0,
        expires = null,
        setIsRemember = false
    if (company && company.limitUser) {
        // limitUser = company.limitUser
        if (Number.isInteger(parseInt(company.limitUser, 10))) {
            limitUser = parseInt(company.limitUser, 10)
        }
    }

    if (typeof isRemember === 'boolean' && isRemember === true) {
        setIsRemember = true
        expires = expiresDay
    }

    setCookie(BSRS_ACCESS_TOKEN, token, expires)
    setCookie(REFRESH_TOKEN, refreshToken, expires)

    if (refreshToken) {
        console.log("0000", refreshTokenExpiresDate)
        if (!!refreshTokenExpiresDate) {
            setCookie(REFRESH_TOKEN_EXPIRES_DATE, refreshTokenExpiresDate, expires)
        } else {
            let decode = await jwt.decode(refreshToken)
            console.log("1111", decode)
            if (!!decode) {
                let exp = moment.unix(decode.exp)
                setCookie(REFRESH_TOKEN_EXPIRES_DATE, exp.format(dateTimeFormat.apiFullDateTime), expires)
            }
        }
    }
    // setCookie(SERVICE_TOKEN, access_token, expires)
    // setCookie(SERVICE_TOKEN_EXPIRES, expires_on, expires)
    setCookie(EXPIRES_ON, expires_on, expires)
    setCookie(IS_INTEGRATION, isIntegration, expires)
    setCookie(USER_ID, id, expires)
    setCookie(LIMIT_USERS, limitUser, expires)
    setCookie(FIRST_NAME, firstName, expires)
    setCookie(EMAIL, email, expires)
    setCookie(IS_USER_AD, isUserActiveDirectory, expires)
    setCookie(SYSTEM, system_key, expires)
    setCookie(COMPANY_CODE, companyCode, expires)
    setCookie(IS_REMEMBER, setIsRemember, expires)

    setCookie(IS_IMPORTUSERFROMO365, typeof isImportUserFromO365 === 'boolean' ? isImportUserFromO365 : false, expires)
    setCookie(IS_IMPORTUSERFROMEXCEL, typeof isImportUserFromExcel === 'boolean' ? isImportUserFromExcel : false, expires)
    setCookie(IS_IMPORTUSERFROMAD, typeof isImportUserFromAD === 'boolean' ? isImportUserFromAD : false, expires)
    setCookie(IS_SYNCROLEANDPOLICY, typeof isSyncRoleAndPolicy === 'boolean' ? isSyncRoleAndPolicy : false, expires)
}

export function getLimitUser() {
    const get = getCookie(LIMIT_USERS)
    let dataReturn = -1
    if (get && Number.isInteger(parseInt(get, 10))) {
        dataReturn = parseInt(get, 10)
    }
    return dataReturn
}

export function getSystem() {
    const system = getCookie(SYSTEM)
    return system ? system : ''
}

export function getCompanyCode() {
    return getCookie(COMPANY_CODE)
}

export function getUserFirstName() {
    return (getCookie(FIRST_NAME))
}

export function setRoomToken(room, client_id, api_server_url) {
    setCookie(ROOM, room)
    setCookie(CLIENT_ID, client_id)
    setCookie(API_URL, api_server_url)
}

export function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN)
    // removeCookie(SERVICE_TOKEN)
    // removeCookie(SERVICE_TOKEN_EXPIRES)
    removeCookie(USER_ID)
    removeCookie(IS_INTEGRATION)
    removeCookie(LIMIT_USERS)
    removeCookie(FIRST_NAME)
    removeCookie(EMAIL)
    removeCookie(IS_USER_AD)
    removeCookie(SYSTEM)
    removeCookie(COMPANY_CODE)
    removeCookie(IS_REMEMBER)
    removeCookie(EXPIRES_ON)
    removeCookie(REFRESH_TOKEN)
    removeCookie(REFRESH_TOKEN_EXPIRES_DATE)

    removeCookie(IS_IMPORTUSERFROMO365)
    removeCookie(IS_IMPORTUSERFROMEXCEL)
    removeCookie(IS_IMPORTUSERFROMAD)
    removeCookie(IS_SYNCROLEANDPOLICY)
}

export function getResultPerPage() {
    return 10
}

export function getImport() {
    let isImportUserFromO365 = false
        , isImportUserFromExcel = false
        , isImportUserFromAD = false

    if (getCookie(IS_IMPORTUSERFROMO365) === 'true' || getCookie(IS_IMPORTUSERFROMO365) === true) {
        isImportUserFromO365 = true
    }

    if (getCookie(IS_IMPORTUSERFROMEXCEL) === 'true' || getCookie(IS_IMPORTUSERFROMEXCEL) === true) {
        isImportUserFromExcel = true
    }

    if (getCookie(IS_IMPORTUSERFROMAD) === 'true' || getCookie(IS_IMPORTUSERFROMAD) === true) {
        isImportUserFromAD = true
    }

    return {
        isImportUserFromO365: isImportUserFromO365,
        isImportUserFromExcel: isImportUserFromExcel,
        isImportUserFromAD: isImportUserFromAD
    }
}

export function getIsSyncRoleAndPolicy() {
    let isSyncRoleAndPolicy = false

    if (getCookie(IS_SYNCROLEANDPOLICY) === 'true' || getCookie(IS_SYNCROLEANDPOLICY) === true) {
        isSyncRoleAndPolicy = true
    }

    return isSyncRoleAndPolicy
}



// WEBPACK FOOTER //
// ./src/lib/auth.js